/**
 * @export taskStartModel
 * @constant startModel
 * @param 0 1 2 3
 * @description task 启动模型 默认四种类型 标准 ，栈顶，单任务，单实例
 * @author lei.you
 * @date 2018/3/15
 * */
const startModel={
  standard:0,
  singleTop:1,
  singTask:2,
  singInstance:3
}
Object.freeze(startModel);
export default  startModel;
